import styled from "styled-components";

interface SVGWrapperProps {
  color: string;
}

export const SVGWrapper = styled.div<SVGWrapperProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  overflow: hidden;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }

  #background-rect {
    fill: ${(props) => props.color};
  }
`;
